


































import { defineComponent, toRefs } from '@vue/composition-api';

const name = 'popup';
export default defineComponent({
  name,
  props: {
    value: {
      type: Boolean,
    },
    height: {
      type: [Number, String],
      default: '',
    },
    clazz: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    cancelText: {
      type: String,
      default: '',
    },
    confirmText: {
      type: String,
      default: '',
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['confirm', 'cancel', 'input'],
  setup(props, { emit }) {
    const { height, title, cancelText, confirmText } = toRefs(props);

    const styleObj = (): any => {
      const _height = height.value;

      const heightStr = '300px';
      return { height: _height || heightStr };
    };

    function hasHeader(): boolean {
      return cancelText.value.length > 0 || confirmText.value.length > 0 || title.value.length > 0;
    }

    const handleSubmit = (): void => {
      emit('confirm');
    };

    const closePopup = (): void => {
      if (hasHeader()) {
        emit('cancel');
      } else {
        emit('confirm');
        emit('input', false);
      }
    };
    return {
      name,
      styleObj: styleObj(),
      handleSubmit,
      closePopup,
      hasHeader: hasHeader(),
    };
  },
});
